export const POST_TYPE_NAME = {
  LEARNING: 'Learning',
  ASSESSMENT: 'Assessment',
  VIDEO_CONFERENCE: 'Video Conference'
};

export const USER_ROLE = {
  LEARNER: 'learner',
  TEACHER: 'teacher',
  DESIGNER: 'designer'
};

export const TAG = {
  LU_OWNER: 'lu_owner',
  LU_INSTRUCTOR: 'lu_instructor',
  LU_ASSESSOR: 'lu_assessor',
  ADDED: 'added'
};

export const LEARNING_UNIT_TYPE = {
  OBEM: 'OBEM',
  GENERAL: 'General'
};

export const LEARNING_UNIT_STATUS = {
  DRAFT: 'Draft',
  SUBMITTED_FOR_PUBLICATION: 'Submitted for Publication',
  PUBLISHED: 'Published'
};

export const LEARNING_UNIT_LEVEL = {
  CAREER_SPECIFIC: 'CAREER_SPECIFIC',
  ACADEMIC_FOCUS: 'ACADEMIC_FOCUS'
};

export const FEATURE = {
  cart: 'Cart',
  purchase_buynow: 'purchase_buynow',
  change_email: 'change_email'
};

export const ORIGINAL_LANGUAGE = {
  ENGLISH: 'en',
  THAI: 'th'
};

export default {
  POST_TYPE_NAME,
  USER_ROLE,
  TAG,
  LEARNING_UNIT_TYPE,
  LEARNING_UNIT_STATUS,
  LEARNING_UNIT_LEVEL,
  FEATURE,
  ORIGINAL_LANGUAGE
};
